

import { avatarRules } from "../../../../../arc/forms/avatar.js";
import { apiFetch } from "../../../../assets/apiFetch.js";



export const uploadAvatar = async file=>{
    const formData = new FormData();
    formData.append(avatarRules.fieldName, file, avatarRules.outputName);

    const reply = await apiFetch.post("user/avatar", {
        trait:opt=>{
            opt.body = formData;
            return opt;
        }
    });

    if (!reply.isOk) {
        throw new Error(reply.error?.message || "avatar_upload_failed");
    }

    return reply.result?.avatar;
};
